<template>
  <div class="w-full bg-blue-400/10">
    <ul class="container-extend-wrap flex flex-wrap">
      <li
        v-for="(item, index) in adLinks"
        :key="item.title"
        class="w-1/2 border-solid border-gray-300 odd:border-r tablet:w-1/4 tablet:odd:border-r-0 [&:not(:nth-last-child(-n+2))]:border-b tablet:[&:not(:nth-last-child(-n+2))]:border-b-0"
      >
        <TheNuxtLink
          :id="isCN && index === 1 ? 'tracking_adImg' : undefined"
          :to="provideFormatUrl(item.url)"
          :title="item.title"
          class="flex items-center justify-center p-2 hover:text-blue-500 desktop:min-h-[86px]"
        >
          <div class="text-center">
            <span class="block text-sm font-bold tablet:text-lg">
              {{ item.title }}
            </span>
            <span class="hidden text-sm tablet:block">
              {{ item.description }}
            </span>
          </div>
        </TheNuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  const { isCN } = useLanguage();
  const { provideFormatUrl } = useFormatUrl();

  const homeStore = useHomeStore();
  const { adLinks } = storeToRefs(homeStore);
</script>
